<div>
    <!-- prettier-ignore -->
    <app-shared-ranking-list
        [departmentType]="departmentType"
        [pathRoute]="pathRoute"
    ></app-shared-ranking-list>
</div>
